import React, { FC, useEffect } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import { useAppDispatch } from '../../../services/store';
import { postMemberSettings } from '../../../services/store/modules/app-controls';
import AlertDetailsContainer from './AlertDetailsContainer/AlertDetailsContainer';
import useNotifications from './hooks/use-notifications';
import NotificationsHomePage from './NotificationsHomePage/NotificationsHomePage';

const notificationsBasePath = '/maps/notifications';

const AlertDetailsDefault = () => {
  const { id } = useParams<{ id: string }>();
  return <AlertDetailsContainer id={id} />;
};

const NotificationsFeature: FC = () => {
  const { path } = useRouteMatch();
  const dispatch = useAppDispatch();

  useNotifications();

  useEffect(() => {
    dispatch(
      postMemberSettings({
        notificationConfig: {
          lastSeenDate: new Date().toISOString(),
        },
      }),
    );
  }, [dispatch]);

  return (
    <Switch>
      {/* Redirect for the default notifications route */}
      <Route path={notificationsBasePath} exact>
        <Redirect to={`${path}/all`} />
      </Route>
      {/* Notifications tabs page */}
      <Route path={`${path}/:pagename(all|alerts)`} exact>
        <NotificationsHomePage />
      </Route>

      {/* Alert details page */}
      <Route path={`${notificationsBasePath}/alerts/:id`}>
        <AlertDetailsDefault />
      </Route>
    </Switch>
  );
};

export default NotificationsFeature;
